import { render, staticRenderFns } from "./UpdateSuppliers.vue?vue&type=template&id=c83d426a&scoped=true&"
import script from "./UpdateSuppliers.vue?vue&type=script&lang=js&"
export * from "./UpdateSuppliers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83d426a",
  null
  
)

export default component.exports